

















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class Button extends Vue {
  @Prop({ default: "disable" })
  private status?: string;
  @Prop({ default: "" })
  private text?: string;
  @Prop({ default: "" })
  private type?: string;

  private mounted() {}

  private clickButton() {
    if (this.status !== "disable" && this.status !== "loading") {
      this.$emit("click");
    }
  }
}
